export const brandsConstants = {
    BRANDS_SUCCESS: 'BRANDS_SUCCESS',
    BRANDS_REQUEST: 'BRANDS_REQUEST',
    BRANDS_FAILURE: 'BRANDS_FAILURE',
    BRAND_DEFAULT_SUCCESS: 'BRAND_DEFAULT_SUCCESS',
    BRAND_DEFAULT_FAILURE: 'BRAND_DEFAULT_FAILURE',
    BRANDS_ALL_SUCCESS: 'BRANDS_ALL_SUCCESS',
};

export const FORM_TYPE = {
    NEW: 'NEW',
    EDIT: 'EDIT',
};

export const BackgroundType = {
    Gradient: 0,
    Solid: 1,
};

export const FontType = {
    Arial: 'Arial',
    'Book Antiqua': 'Book Antiqua',
    'Courier New': 'Courier New',
    Georgia: 'Georgia',
    Helvetica: 'Helvetica',
    Rubik: 'Rubik',
    Tahoma: 'Tahoma',
    'Times New Roman': 'Times New Roman',
    'Trebuchet MS': 'Trebuchet MS',
    Verdana: 'Verdana',
};

export const ButtonType = {
    Sharp: '0px',
    'Softly Rounded': '8px',
    Rounded: '30px',
};
